<template>
  <b-modal title="Lista Para Impressão" v-model="show" size="xl">
    <div id="AtividadesPrint">
      <b-row>
        <b-col cols="4"><b-form-checkbox> Orçamento Gerado </b-form-checkbox> </b-col>
        <b-col cols="4"><b-form-checkbox> Relatório Emitido </b-form-checkbox> </b-col>
        <b-col cols="4"><b-form-checkbox> Relatório Enviado </b-form-checkbox> </b-col>
      </b-row>
      <b-card no-body bg-variant="info" text-variant="white">
        <b-card-body class="text-center p-0 pt-3 pr-3">
          <b-form-group label="LISTA:" label-for="lista" label-cols-sm="1" label-align-sm="right">
            <b-form-input id="lista" v-model="atividade.descricao" />
          </b-form-group>

          <b-row>
            <b-col cols="6">
              <b-form-group label="CLIENTE:" label-for="cliente" label-cols-sm="2" label-align-sm="right">
                <b-form-select v-model="atividade.cliente">
                  <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
                    >{{ cliente.nome }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-cols-sm="2" label="DATA:" label-align-sm="right" label-for="data">
                <b-form-datepicker
                  id="data"
                  v-model="atividade.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-table bordered hover small head-variant="light" :items="lista" :fields="fields.trabalhoPrint"></b-table>
      <b-alert :show="isDuplicate" variant="warning">Existem números de SGCQ repetidos na lista.</b-alert>
    </div>
    <template #modal-footer>
      <b-button variant="primary" v-print="'#AtividadesPrint'">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useAtividadeStore } from "@/stores/AtividadeStore";
import { useClienteStore } from "@/stores/ClienteStore";
import TableFields from "@/tools/TableFields";
import Atividade from "@/models/Avulso";

export default {
  name: "ModalDeImpressaoDeListaAtividade",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      atividade: new Atividade(0, "Nova Atividade", "", new Date(), "", ""),
      isDuplicate: false,
      lista: [],
    };
  },

  methods: {
    testarRepetido() {
      var lista = this.getTrabalhos;
      var valueArr = lista.map(function (item) {
        return item.sgcq;
      });
      this.isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
    },

    call(atividade) {
      this.atividade = atividade;
      this.lista = this.getTrabalhos;
      this.testarRepetido();
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const atividadeStore = useAtividadeStore();
    const { getTrabalhos } = storeToRefs(atividadeStore);
    const clienteStore = useClienteStore();

    return {
      store,
      atividadeStore,
      getTrabalhos,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
